import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [],
  next: null,
  unreadCount: 0,
  socketStatus: "idle", // idle | connecting | open | closed
};

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    setList: (state, action) => {
      const { notifications, next, unread_count, append } = action.payload;
      if (append) {
        const existingIds = new Set(state.items.map((n) => n.id));
        state.items = [...state.items, ...notifications.filter((n) => !existingIds.has(n.id))];
      } else {
        state.items = notifications;
      }
      state.next = next ?? null;
      if (typeof unread_count === "number") {
        state.unreadCount = unread_count;
      }
    },

    // Live socket push — can race with a list refetch, so upsert by id.
    upsertNotification: (state, action) => {
      const notification = action.payload;
      const exists = state.items.some((n) => n.id === notification.id);
      if (!exists) {
        state.items = [notification, ...state.items];
        if (!notification.is_read) {
          state.unreadCount += 1;
        }
      }
    },

    markRead: (state, action) => {
      const id = action.payload;
      const item = state.items.find((n) => n.id === id);
      if (item && !item.is_read) {
        item.is_read = true;
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      }
    },

    markAllRead: (state) => {
      state.items.forEach((n) => {
        n.is_read = true;
      });
      state.unreadCount = 0;
    },

    removeNotification: (state, action) => {
      const id = action.payload;
      const item = state.items.find((n) => n.id === id);
      if (item && !item.is_read) {
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      }
      state.items = state.items.filter((n) => n.id !== id);
    },

    setUnreadCount: (state, action) => {
      state.unreadCount = action.payload;
    },

    setSocketStatus: (state, action) => {
      state.socketStatus = action.payload;
    },

    resetNotifications: () => initialState,
  },
});

export const {
  setList,
  upsertNotification,
  markRead,
  markAllRead,
  removeNotification,
  setUnreadCount,
  setSocketStatus,
  resetNotifications,
} = notificationsSlice.actions;

export default notificationsSlice.reducer;
